import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import { editMeeting } from "../../api/meetings";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";

const RescheduleMeetingModal = ({ meeting, show, onHide, onReschedule, setIsLoading, isLoading }) => {
  const dispatch = useDispatch();
  const token = useSelector(state => state.userReducer.token);
  const userTimeZone = moment.tz.guess();

  // Local state to hold new date and time values
  const [newDate, setNewDate] = useState(null);
  const [newFromTime, setNewFromTime] = useState("");
  const [newToTime, setNewToTime] = useState("");

  // Pre-fill the fields when the meeting changes (or when the modal is opened)
  useEffect(() => {
    if (meeting) {
      // Convert stored UTC times to the user's local timezone
      const startLocal = moment.tz(meeting.fromTime, "UTC").tz(userTimeZone);
      const endLocal = moment.tz(meeting.toTime, "UTC").tz(userTimeZone);

      setNewDate(startLocal.toDate());
      setNewFromTime(startLocal.format("HH:mm"));
      setNewToTime(endLocal.format("HH:mm"));
    }
  }, [meeting, userTimeZone]);

  const handleReschedule = async () => {
    if (!newDate || !newFromTime || !newToTime) {
      alert("Please select a new date and time.");
      return;
    }
    setIsLoading(true);
    try {
      const eventDate = moment(newDate).format("YYYY-MM-DD");
      // Format new date and times as UTC before updating in the database
      const dateStr=  moment.utc(newDate);
      const fromUTC = newFromTime
      ? moment
          .tz(eventDate + " " + newFromTime, userTimeZone)
          .utc()
          .format()
      : "";
      const toUTC = newToTime
      ? moment
          .tz(eventDate + " " + newToTime, userTimeZone)
          .utc()
          .format()
      : "";
      const res = await editMeeting({
        values: { eventId: meeting._id, date: dateStr, fromTime: fromUTC, toTime: toUTC,description:meeting.description },
        dispatch,
        token
      });
      if (res?.status === "SUCCESS") {
        success(res?.message);
        await onReschedule(); // callback to refresh the meetings list in parent
        onHide();
      } else {
        failed(res?.message);
      }
    } catch (error) {
      // console.error("Error rescheduling meeting:", error);
      failed("Failed to reschedule the meeting.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={show} toggle={onHide} size="lg">
      {isLoading ? (<Loader/>) : null}
      <ModalHeader toggle={onHide}>Reschedule Meeting</ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          <Col md={12}>
            <Label>New Date</Label>
            <DatePicker
              selected={newDate}
              onChange={setNewDate}
              dateFormat="yyyy-MM-dd"
              className="form-control"
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Label>New From Time</Label>
            <input
              type="time"
              className="form-control"
              value={newFromTime}
              onChange={(e) => setNewFromTime(e.target.value)}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Label>New To Time</Label>
            <input
              type="time"
              className="form-control"
              value={newToTime}
              onChange={(e) => setNewToTime(e.target.value)}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleReschedule}>Reschedule</Button>
        <Button color="secondary" onClick={onHide}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default RescheduleMeetingModal;
